"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBarConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var responsive_1 = require("../_chartCreators/responsive");
var common_1 = require("../_util/common");
var BAR_TEMPLATE = {
    chart: {
        type: "bar",
    },
    plotOptions: {
        bar: {
            maxPointWidth: commonConfiguration_1.MAX_POINT_WIDTH,
            dataLabels: {
                enabled: true,
                padding: 2,
            },
        },
        series: {
            states: {
                hover: {
                    enabled: false,
                },
            },
        },
    },
    yAxis: [
        {
            stackLabels: {
                enabled: false,
            },
        },
    ],
};
function getBarConfiguration(config) {
    var barConfiguration = cloneDeep_1.default(BAR_TEMPLATE);
    if ((config === null || config === void 0 ? void 0 : config.enableCompactSize) && !(config === null || config === void 0 ? void 0 : config.zoomInsight)) {
        var reversed = true;
        var _a = common_1.getAxesCounts(config), xAxesCount = _a[0], yAxesCount = _a[1];
        return tslib_1.__assign(tslib_1.__assign({}, barConfiguration), { responsive: responsive_1.getCommonResponsiveConfig(reversed, xAxesCount, yAxesCount) });
    }
    return barConfiguration;
}
exports.getBarConfiguration = getBarConfiguration;
//# sourceMappingURL=barConfiguration.js.map